export const isGlobal = (model) => {
    return !model?.orgId
}

export const isMicrosoft = (model = {}) => {
    let microsoftList = [
      'office365',
      'office365_aad',
      'office365_atp',
      'office365_compliance',
      'office365_data_center',
      'office365_dynamics',
      'office365_exchange',
      'office365_flow',
      'office365_forms',
      'office365_insight',
      'office365_power_bi',
      'office365_project',
      'office365_security',
      'office365_sharepoint',
      'office365_skype',
      'office365_stream',
      'office365_teams',
      'office365_workplace',
      'office365_yammer'
    ]

    return Object.values(model.queryParams).find(qp=>{
      return qp.field==='type' && Array.isArray(qp.value) && qp.value.find(f=>microsoftList.includes(f))
    })
  }